import { createAPIActionGenerator, APIRequest } from 'utils/apidata';

export type UninstallRedirect = {
  url: string;
};

export type UninstallOrganizationRequest = APIRequest<UninstallRedirect> & {
  provider: string;
  providerId: string;
  organizationType: number;
};

export const generators = {
  uninstallOrganization: createAPIActionGenerator<
    UninstallOrganizationRequest,
    UninstallRedirect
  >({
    prefix: 'INSTALLATIONS/UNINSTALL_ORGANIZATION',
  }),
};
